<template>
  <el-dialog
    title="仓库调动"
    :visible="visible"
    width="600px"
    @close="handleDialogMobilizeClose"
    @open="handleDialogMobilizeOpen"
  >
    <base-form
      style="margin-bottom: 12px"
      :form-items="formItemsDialogMobilize"
      :merge-form="formDialogMobilize"
      :reset="false"
      form-name="formDialogMobilize"
      :inline="false"
      :submit="false"
    ></base-form>

    <div slot="footer" class="dialog-footer">
      <el-button @click="handleDialogMobilizeClose">取 消</el-button>
      <el-button type="primary" @click="confirmMobilization">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import BaseForm from "@/components/BaseForm/BaseForm.vue";
import { getWarehouseWorkers } from "../../../api/stock.js";

export default {
  name: "DialogMobilize",
  components: { BaseForm },
  model: {
    prop: "visible",
    event: "toggle",
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    form: {
      type: Object,
      default: () => ({}),
    },
    searchParams: {
      type: Object,
      default: null,
    },
  },
  data() {
    const _this = this;
    return {
      formItemsDialogMobilize: [
        {
          tag: "input",
          slot: "",
          itemAttrs: {
            label: "姓名",
            class: "",
          },
          attrs: {
            key: "admin_name",
            value: "",
            placeholder: "选择姓名",
            filterable: true,
            loading: false,
            style: "width: 100%",
            disabled: true,
          },
          listeners: {},
          getAttrs() {},
          ifRender() {
            return true;
          },
        },
        {
          tag: "input",
          slot: "",
          itemAttrs: {
            label: "手机号吗",
            class: "",
          },
          attrs: {
            key: "phone",
            value: "",
            placeholder: "",
            disabled: true,
          },
          listeners: {},
          getAttrs() {},
          ifRender() {
            return true;
          },
        },
        {
          tag: "input",
          slot: "",
          itemAttrs: {
            label: "部门",
            class: "",
          },
          attrs: {
            key: "group_name",
            value: "",
            placeholder: "",
            disabled: true,
          },
          listeners: {},
          getAttrs() {},
          ifRender() {
            return true;
          },
        },
        {
          tag: "input",
          slot: "",
          itemAttrs: {
            label: "所属仓库",
            class: "",
          },
          attrs: {
            key: "storehouse_name",
            value: "",
            placeholder: "",
            disabled: true,
          },
          listeners: {},
          getAttrs() {},
          ifRender() {
            return true;
          },
        },

        {
          tag: "select",
          slot: "",
          itemAttrs: {
            label: "调入仓库",
            class: "",
          },
          attrs: {
            key: "stock_storehouse_id",
            value: "",
            placeholder: "选择所属仓库",
            filterable: true,
            remote: true,
            loading: false,
            "remote-method": _this.searchWarehouse,
            options: [],
            style: "width: 100%",
          },
          listeners: {
            change(value) {
              _this.formDialogMobilize.stock_storehouse_id = value;
            },
          },
          getAttrs() {},
          ifRender() {
            return true;
          },
        },
      ],
      formDialogMobilize: {
        admin_id: null,
        stock_storehouse_id: null,
        admin_name: "",
        group_name: "",
        phone: "",
        storehouse_name: "",
      },
    };
  },
  methods: {
    async searchWarehouse(query) {
      try {
        let params = {};
        if (query) {
          params = { page: 1, page_size: 20, storehouse_name: query };
        } else {
          params = { page: 1, page_size: 500 };
        }
        const res = await this.$api.searchWarehouse(params);
        if (res.data.code !== 200) {
          this.$message({ message: res.data.msg, type: "error" });
        } else {
          this.formItemsDialogMobilize.find(
            (item) => item.attrs.key === "stock_storehouse_id"
          ).attrs.options = res.data.data.list.map((l) => ({
            label: l.storehouse_name,
            value: l.stock_storehouse_id,
          }));
        }
      } catch (err) {
        console.log("searchWarehouse error", err);
      }
    },
    async handleDialogMobilizeOpen() {
      if (this.searchParams && typeof this.searchParams === "object") {
        try {
          const res = await getWarehouseWorkers({
            page: 1,
            page_size: 1,
            ...this.searchParams,
          });
          if (res.data.data.list && res.data.data.list[0]) {
            res.data.data.list[0].stock_storehouse_id = "";
            Object.assign(this.formDialogMobilize, res.data.data?.list[0]);
          }
        } catch (error) {
          console.log("handleDialogMobilizeOpen error", error);
        }
      } else {
        Object.assign(this.formDialogMobilize, this.form);
      }
      this.searchWarehouse();
    },
    handleDialogMobilizeClose() {
      this.$emit("toggle", false);
      this.formDialogMobilize = this.$options.data().formDialogMobilize;
    },
    confirmMobilization() {
      const params = {
        admin_id: this.formDialogMobilize.admin_id,
        stock_storehouse_id: this.formDialogMobilize.stock_storehouse_id,
      };
      this.$api
        .mobilizeWarehouse(params)
        .then((res) => {
          if (res.data.code !== 200) {
            this.$message({ message: res.data.msg, type: "error" });
          } else {
            this.$message({ message: "调动成功", type: "success" });
            this.$emit("toggle", false);
            this.formDialogMobilize = this.$options.data().formDialogMobilize;
            this.$emit("confirm");
          }
        })
        .catch((err) => {
          this.$message({ message: err, type: "error" });
        });
    },
  },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/pages/WarehouseWorkerList/components/DialogMobilize.vue